<script setup>
import { watch, ref } from 'vue';

const props = defineProps(['dashboardData','date']);
const open = ref(false);
const handleChange = (val) => {
    open.value = !open.value;
}
</script>
<template>
    <div>
        <el-collapse v-model="activeNames" @change="handleChange">
            <el-collapse-item :title="`Total Entries By Forms (${date[0]} to ${date[1]}) `">
                <div v-for="(data,index) in dashboardData?.allFormsDataCount" :key="index" class="fv-dbw-form-list-item">
                    <span class="fv-dbw-form-list">
                        {{data.formName}} ({{data.plugin}})
                    </span>
                    <span class="fv-dbw-form-list-count">{{data.count}}</span>
                </div>
            </el-collapse-item>
        </el-collapse>
    </div>
</template>